import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AIChatThreadState {
  isChatOpen: boolean
  threadId: string | null
  messages: any[]
}

const initialState: AIChatThreadState = {
  isChatOpen: false,
  threadId: null,
  messages: [],
}

const aiChatThreadSlice = createSlice({
  name: 'aiChatThread',
  initialState,
  reducers: {
    loadAIChatThread: (state, action: PayloadAction<{ threadId: string; messages: any[] }>) => {
      state.threadId = action.payload.threadId
      state.messages = action.payload.messages
    },
    updateThreadId: (state, action: PayloadAction<string>) => {
      state.threadId = action.payload
    },
    updateIsChatOpen: (state, action: PayloadAction<boolean>) => {
      state.isChatOpen = action.payload
    }
  },
})

export const { loadAIChatThread, updateIsChatOpen } = aiChatThreadSlice.actions

export const selectAIChatThread = (state: any) => state.aiChatThread.messages
export const selectThreadId = (state: any) => state.aiChatThread.threadId
export const selectIsChatOpen = (state: any) => state.aiChatThread.isChatOpen

export default aiChatThreadSlice.reducer
